import { render, staticRenderFns } from "./UserFormOrder.vue?vue&type=template&id=47f34c36&scoped=true"
import script from "./UserFormOrder.vue?vue&type=script&lang=js"
export * from "./UserFormOrder.vue?vue&type=script&lang=js"
import style0 from "./UserFormOrder.scss?vue&type=style&index=0&id=47f34c36&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f34c36",
  null
  
)

export default component.exports